import { Pipe, PipeTransform } from '@angular/core';
import {LocationData} from '../../types/location/location-data';

@Pipe({
  name: 'addressType'
})
export class AddressTypePipe implements PipeTransform {

  transform(addresses: LocationData[], allowedTypes: string[]): any {
    return addresses.filter(
      address => allowedTypes.includes(address.locationType)
    );
  }

}
